import React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { format, startOfMonth, eachMonthOfInterval, subMonths } from 'date-fns';

export default function SpendingChart({ receipts = [], months = 6 }) {
  const endDate = new Date();
  const startDate = subMonths(endDate, months - 1);
  const monthlyData = eachMonthOfInterval({ start: startDate, end: endDate }).map(month => {
    const ms = startOfMonth(month);
    const monthReceipts = receipts.filter(r => { const d = new Date(r.date); return d.getMonth() === ms.getMonth() && d.getFullYear() === ms.getFullYear(); });
    return {
      month: format(month, 'MMM yyyy'),
      total: monthReceipts.reduce((sum, r) => sum + (r.amount || 0), 0),
      taxDeductible: monthReceipts.filter(r => r.tax_deductible).reduce((sum, r) => sum + ((r.amount || 0) * (r.tax_split_percentage || 100) / 100), 0)
    };
  });
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload?.length) return (
      <div className="bg-white p-3 rounded-xl shadow-lg border border-slate-100">
        <p className="font-medium text-slate-900">{label}</p>
        <p className="text-emerald-600 text-sm">Total: ${(payload[0]?.value || 0).toLocaleString()}</p>
        <p className="text-teal-600 text-sm">Tax Deductible: ${(payload[1]?.value || 0).toLocaleString()}</p>
      </div>
    );
    return null;
  };
  return (
    <div className="h-[300px] w-full" data-testid="spending-chart">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={monthlyData} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
          <defs>
            <linearGradient id="colorTotal" x1="0" y1="0" x2="0" y2="1"><stop offset="5%" stopColor="#10b981" stopOpacity={0.3} /><stop offset="95%" stopColor="#10b981" stopOpacity={0} /></linearGradient>
            <linearGradient id="colorTax" x1="0" y1="0" x2="0" y2="1"><stop offset="5%" stopColor="#14b8a6" stopOpacity={0.3} /><stop offset="95%" stopColor="#14b8a6" stopOpacity={0} /></linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
          <XAxis dataKey="month" axisLine={false} tickLine={false} tick={{ fill: '#94a3b8', fontSize: 12 }} />
          <YAxis axisLine={false} tickLine={false} tick={{ fill: '#94a3b8', fontSize: 12 }} tickFormatter={(v) => `$${v >= 1000 ? `${(v/1000).toFixed(0)}k` : v}`} />
          <Tooltip content={<CustomTooltip />} />
          <Area type="monotone" dataKey="total" stroke="#10b981" strokeWidth={2} fillOpacity={1} fill="url(#colorTotal)" />
          <Area type="monotone" dataKey="taxDeductible" stroke="#14b8a6" strokeWidth={2} fillOpacity={1} fill="url(#colorTax)" />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
